/* PDP pack picker: writes the chosen pack size into Dawn's quantity input
   (and the sticky ATC's hidden quantity) so every add-to-cart path adds the
   right number of pairs. Dawn resets the quantity to 1 on each variant
   change, so the choice is re-applied on PUB_SUB_EVENTS.variantChange. */

class EarbitPackPicker extends HTMLElement {
  connectedCallback() {
    this.onChange = () => this.apply();
    this.addEventListener('change', this.onChange);

    // Someone using the stepper directly means "custom": keep the radios honest.
    this.onQuantityInput = (event) => {
      const input = document.getElementById(this.dataset.quantityId);
      if (!input || event.target !== input || this.applying) return;
      if (!this.isCustom) {
        const custom = this.querySelector('input[name="earbit-pack"][value="custom"]');
        if (custom) custom.checked = true;
        this.setAttribute('data-custom', '');
      }
      this.syncSticky(input.value);
    };
    document.addEventListener('change', this.onQuantityInput);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        // product-info resets the quantity before publishing; re-apply after it settles.
        requestAnimationFrame(() => this.apply());
      });
    }

    this.apply();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    document.removeEventListener('change', this.onQuantityInput);
    if (this.unsubscribeVariant) this.unsubscribeVariant();
  }

  get checked() {
    return this.querySelector('input[name="earbit-pack"]:checked');
  }

  get isCustom() {
    return Boolean(this.checked && this.checked.value === 'custom');
  }

  get quantity() {
    const value = parseInt(this.checked ? this.checked.value : '1', 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  apply() {
    const input = document.getElementById(this.dataset.quantityId);

    if (this.isCustom) {
      // Reveal the stepper and let it lead; just keep the sticky ATC in step.
      this.setAttribute('data-custom', '');
      if (input) this.syncSticky(input.value);
      return;
    }

    this.removeAttribute('data-custom');
    const quantity = this.quantity;
    if (input && String(input.value) !== String(quantity)) {
      input.value = quantity;
      // Let <quantity-input> run its own validation/state update, without
      // our own document listener mistaking it for a manual edit.
      this.applying = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.applying = false;
    }
    this.syncSticky(quantity);
  }

  syncSticky(quantity) {
    document.querySelectorAll('.sticky-atc input[name="quantity"]').forEach((field) => {
      field.value = quantity;
    });
  }
}

customElements.define('earbit-pack-picker', EarbitPackPicker);
